import type { TableColumnsType } from 'antd';

interface DataType {
  [key: string]: any;
}
export const ConcernQueryHeader = [
  {
    title: 'VIN',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'vin',
    key: 'vin',
    fixed: 'left',
  },
  {
    title: 'Brand',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Model',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: 'Model Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelDescription',
    key: 'modelDescription',
  },
  {
    title: 'Model Year',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelYear',
    key: 'modelYear',
  },
  {
    title: 'Plant',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'plant',
    key: 'plant',
  },
  {
    title: 'Market',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'market',
    key: 'market',
  },
  {
    title: 'Trim',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'trim',
    key: 'trim',
  },
  {
    title: 'Body Style',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'bodyStyle',
    key: 'bodyStyle',
  },
  {
    title: 'Driver',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'driver',
    key: 'driver',
  },
  {
    title: 'Engine',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'engine',
    key: 'engine',
  },
  {
    title: 'Engine Powertrain Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'enginePowertrainDescription',
    key: 'enginePowertrainDescription',
  },
  {
    title: 'Transmission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'transmission',
    key: 'transmission',
  },
  {
    title: 'Emission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'emission',
    key: 'emission',
  },
  {
    title: 'Source Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceType',
    key: 'sourceType',
  },
  {
    title: 'Source SW Version',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceSoftwareVersion',
    key: 'sourceSoftwareVersion',
  },
  {
    title: 'Concern Name',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'concernName',
    key: 'concernName',
    ellipsis: true,
  },
  {
    title: 'Total Distance Miles',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoMiles',
    key: 'odoMiles',
  },
  {
    title: 'Total Distance KM',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoKm',
    key: 'odoKm',
  },
  {
    title: 'Source File',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceFile',
    key: 'sourceFile',
  },
  {
    title: 'Timezone Offset Min',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'timezoneOffsetMinutes',
    key: 'timezoneOffsetMinutes',
  },
  {
    title: 'Global Time',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'globalTime',
    key: 'globalTime',
  },
  {
    title: 'Event Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'eventTimestamp',
    key: 'eventTimestamp',
  },
  {
    title: 'Session Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sessionTimestamp',
    key: 'sessionTimestamp',
  },
  {
    title: 'Data Read Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dataReadType',
    key: 'dataReadType',
  },
  {
    title: 'Build Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'buildDate',
    key: 'buildDate',
  },
  {
    title: 'Warranty Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'warrantyDate',
    key: 'warrantyDate',
  },
  {
    title: 'Country',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'country',
    key: 'country',
  },
  {
    title: 'Session Id',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sessionId',
    key: 'sessionId',
  },
];

export const applicationQueryHeader = [
  {
    title: 'VIN',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'vin',
    key: 'vin',
    fixed: 'left',
  },
  {
    title: 'Brand',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Model',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: 'Model Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelDescription',
    key: 'modelDescription',
  },
  {
    title: 'Model Year',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelYear',
    key: 'modelYear',
  },
  {
    title: 'Plant',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'plant',
    key: 'plant',
  },
  {
    title: 'Market',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'market',
    key: 'market',
  },
  {
    title: 'Trim',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'trim',
    key: 'trim',
  },
  {
    title: 'Body Style',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'bodyStyle',
    key: 'bodyStyle',
    ellipsis: true,
  },
  {
    title: 'Driver',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'driver',
    key: 'driver',
  },
  {
    title: 'Engine',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'engine',
    key: 'engine',
  },
  {
    title: 'Engine Powertrain Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'enginePowertrainDescription',
    key: 'enginePowertrainDescription',
  },
  {
    title: 'Transmission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'transmission',
    key: 'transmission',
  },
  {
    title: 'Emission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'emission',
    key: 'emission',
  },
  {
    title: 'Source Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceType',
    key: 'sourceType',
  },
  {
    title: 'Source SW Version',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceSoftwareVersion',
    key: 'sourceSoftwareVersion',
  },
  {
    title: 'Application ID',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'applicationId',
    key: 'applicationId',
  },
  {
    title: 'Application Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'applicationDescription',
    key: 'applicationDescription',
    ellipsis: true,
  },
  {
    title: 'Application Completion Status',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'applicationCompletionStatus',
    key: 'applicationCompletionStatus',
  },
  {
    title: 'Application Duration',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'applicationDuration',
    key: 'applicationDuration',
  },
  {
    title: 'Source File',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceFile',
    key: 'sourceFile',
  },
  {
    title: 'Candidate Name',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'candidateName',
    key: 'candidateName',
    ellipsis: true,
  },
  {
    title: 'Topix Code',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixCode',
    key: 'topixCode',
  },
  {
    title: 'Topix Dealer Name',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixDealerName',
    key: 'topixDealerName',
  },
  {
    title: 'Topix Postal Address',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixPostalAddress',
    key: 'topixPostalAddress',
  },
  {
    title: 'Topix State',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixState',
    key: 'topixState',
  },
  {
    title: 'Topix Postal Code',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixPostalCode',
    key: 'topixPostalCode',
  },
  {
    title: 'Topix Country',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixCountry',
    key: 'topixCountry',
  },
  {
    title: 'Topix User Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixUserType',
    key: 'topixUserType',
    ellipsis: true,
  },
  {
    title: 'Topix User Locale',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixUserLocale',
    key: 'topixUserLocale',
  },
  {
    title: 'Device Info',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'deviceInfo',
    key: 'deviceInfo',
  },
  {
    title: 'Total Distance Miles',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoMiles',
    key: 'odoMiles',
  },
  {
    title: 'Total Distance KM',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoKm',
    key: 'odoKm',
  },
  {
    title: 'Start Date Time',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'startDatetime',
    key: 'startDatetime',
  },
  {
    title: 'End Date Time',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'endDatetime',
    key: 'endDatetime',
  },
  {
    title: 'Global Time',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'globalTime',
    key: 'globalTime',
  },
  {
    title: 'Event Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'eventTimestamp',
    key: 'eventTimestamp',
  },
  {
    title: 'Session Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sessionTimestamp',
    key: 'sessionTimestamp',
  },
  {
    title: 'Timezone Offset Min',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'timezoneOffsetMinutes',
    key: 'timezoneOffsetMinutes',
  },
  {
    title: 'Build Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'buildDate',
    key: 'buildDate',
  },
  {
    title: 'Warranty Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'warrantyDate',
    key: 'warrantyDate',
  },
  {
    title: 'Country',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'country',
    key: 'country',
  },
  {
    title: 'Session Id',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sessionId',
    key: 'sessionId',
  },
];

export const didQueryHeader = [
  {
    title: 'VIN',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'vin',
    key: 'vin',
    fixed: 'left',
  },
  {
    title: 'Brand',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Model',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: 'Model Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelDescription',
    key: 'modelDescription',
  },
  {
    title: 'Model Year',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelYear',
    key: 'modelYear',
  },
  {
    title: 'Plant',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'plant',
    key: 'plant',
  },
  {
    title: 'Market',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'market',
    key: 'market',
  },
  {
    title: 'Trim',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'trim',
    key: 'trim',
  },
  {
    title: 'Body Style',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'bodyStyle',
    key: 'bodyStyle',
  },
  {
    title: 'Driver',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'driver',
    key: 'driver',
  },
  {
    title: 'Engine',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'engine',
    key: 'engine',
  },
  {
    title: 'Engine Powertrain Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'enginePowertrainDescription',
    key: 'enginePowertrainDescription',
  },
  {
    title: 'Transmission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'transmission',
    key: 'transmission',
  },
  {
    title: 'Emission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'emission',
    key: 'emission',
  },
  {
    title: 'Source Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceType',
    key: 'sourceType',
  },
  {
    title: 'Source SW Version',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceSoftwareVersion',
    key: 'sourceSoftwareVersion',
  },
  {
    title: 'Module',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'module',
    key: 'module',
  },
  {
    title: 'DID ID',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'didId',
    key: 'didId',
  },
  {
    title: 'DID Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'didDescription',
    key: 'didDescription',
  },
  {
    title: 'DID Value',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'didValue',
    key: 'didValue',
    ellipsis: true,
  },
  {
    title: 'DID Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'didType',
    key: 'didType',
  },
  {
    title: 'DID Size',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'didSize',
    key: 'didSize',
  },
  {
    title: 'Packet Name',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'packetName',
    key: 'packetName',
  },
  {
    title: 'Packet Values',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'packetValues',
    key: 'packetValues',
  },
  {
    title: 'SW Part Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'softwarePartNumber',
    key: 'softwarePartNumber',
  },
  {
    title: 'HW Part Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'hardwarePartNumber',
    key: 'hardwarePartNumber',
  },
  {
    title: 'ECU Serial Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'ecuSerialNumber',
    key: 'ecuSerialNumber',
  },
  {
    title: 'Ecu Calibration Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'ecuCalibrationNumber',
    key: 'ecuCalibrationNumber',
  },

  {
    title: 'Timezone Offset Min',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'timezoneOffsetMinutes',
    key: 'timezoneOffsetMinutes',
  },
  {
    title: 'Total Distance Miles',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoMiles',
    key: 'odoMiles',
  },
  {
    title: 'Total Distance KM',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoKm',
    key: 'odoKm',
  },
  {
    title: 'Source File',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceFile',
    key: 'sourceFile',
  },
  {
    title: 'Global Time',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'globalTime',
    key: 'globalTime',
  },
  {
    title: 'Event Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'eventTimestamp',
    key: 'eventTimestamp',
  },
  {
    title: 'Session Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'session_timestamp',
    key: 'session_timestamp',
  },
  {
    title: 'Data Read Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dataReadType',
    key: 'dataReadType',
  },
  {
    title: 'Topix Dealer Name',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixDealerName',
    key: 'topixDealerName',
  },
  {
    title: 'Topix Dealer Code',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dealerTopixCode',
    key: 'dealerTopixCode',
  },
  {
    title: 'Topix State',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixState',
    key: 'topixState',
  },
  {
    title: 'Topix Dealer Country',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dealerTopixCountry',
    key: 'dealerTopixCountry',
  },
  {
    title: 'Build Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'buildDate',
    key: 'buildDate',
  },
  {
    title: 'Warranty Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'warrantyDate',
    key: 'warrantyDate',
  },

  {
    title: 'Country',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'country',
    key: 'country',
  },
  {
    title: 'Session Id',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sessionId',
    key: 'sessionId',
  },
];

export const dtcQueryHeader = [
  {
    title: 'VIN',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'vin',
    key: 'vin',
    fixed: 'left',
  },
  {
    title: 'Brand',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'brand',
    key: 'brand',
  },
  {
    title: 'Model',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'model',
    key: 'model',
  },
  {
    title: 'Model Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelDescription',
    key: 'modelDescription',
  },
  {
    title: 'Model Year',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'modelYear',
    key: 'modelYear',
  },
  {
    title: 'Plant',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'plant',
    key: 'plant',
  },
  {
    title: 'Market',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'market',
    key: 'market',
  },
  {
    title: 'Trim',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'trim',
    key: 'trim',
  },
  {
    title: 'Body Style',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'bodyStyle',
    key: 'bodyStyle',
  },
  {
    title: 'Driver',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'driver',
    key: 'driver',
  },
  {
    title: 'Engine',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'engine',
    key: 'engine',
  },
  {
    title: 'Engine Powertrain Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'enginePowertrainDescription',
    key: 'enginePowertrainDescription',
  },
  {
    title: 'Transmission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'transmission',
    key: 'transmission',
  },
  {
    title: 'Emission',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'emission',
    key: 'emission',
  },
  {
    title: 'Source Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceType',
    key: 'sourceType',
  },
  {
    title: 'Source SW Version',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceSoftwareVersion',
    key: 'sourceSoftwareVersion',
  },
  {
    title: 'Module',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'module',
    key: 'module',
  },
  {
    title: 'Base DTC',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dtcBase',
    key: 'dtcBase',
  },
  {
    title: 'Fault Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'faultType',
    key: 'faultType',
  },
  {
    title: 'DTC Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dtcDescription',
    key: 'dtcDescription',
  },
  {
    title: 'Fault Type Description',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'faultTypeDescription',
    key: 'faultTypeDescription',
  },
  {
    title: 'SW Part Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'softwarePartNumber',
    key: 'softwarePartNumber',
  },
  {
    title: 'HW Part Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'hardwarePartNumber',
    key: 'hardwarePartNumber',
  },
  {
    title: 'ECU Serial Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'ecuSerialNumber',
    key: 'ecuSerialNumber',
  },
  {
    title: 'Ecu Calibration Number',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'ecuCalibrationNumber',
    key: 'ecuCalibrationNumber',
  },

  {
    title: 'Timezone Offset Min',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'timezoneOffsetMinutes',
    key: 'timezoneOffsetMinutes',
  },
  {
    title: 'Cal. Date/Time Of Occurrence',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'calculatedTimestamp',
    key: 'calculatedTimestamp',
  },
  {
    title: 'Global Real Time',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'globalRealTime',
    key: 'globalRealTime',
  },
  {
    title: 'Total Distance',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'totalDistance',
    key: 'totalDistance',
  },
  {
    title: 'Main ECU Voltage',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'mainEcuVoltage',
    key: 'mainEcuVoltage',
  },
  {
    title: 'Engine Status Crank',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'engineStatusCrank',
    key: 'engineStatusCrank',
  },
  {
    title: 'Engine Status Running',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'engineStatusRunning',
    key: 'engineStatusRunning',
  },
  {
    title: 'In Car Temperature',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'inCarTemperature',
    key: 'inCarTemperature',
  },
  {
    title: 'Outside Temperature',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'outsideTemperature',
    key: 'outsideTemperature',
  },
  {
    title: 'Power Mode Quality Factor',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'powerModeQualityFactor',
    key: 'powerModeQualityFactor',
  },
  {
    title: 'Power Mode',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'powerMode',
    key: 'powerMode',
  },
  {
    title: 'Engine RPM',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'engineRpm',
    key: 'engineRpm',
  },
  {
    title: 'Vehicle Speed',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'vehicleSpeed',
    key: 'vehicleSpeed',
  },
  {
    title: 'C1',
    width: '50px',
    onHeaderCell: () => {
      return { style: { minWidth: '50px' } }; // Set min-width for the column
    },
    dataIndex: 'c1',
    key: 'c1',
  },
  {
    title: 'C2',
    width: '50px',
    onHeaderCell: () => {
      return { style: { minWidth: '50px' } }; // Set min-width for the column
    },
    dataIndex: 'c2',
    key: 'c2',
  },
  {
    title: 'C3',
    width: '50px',
    onHeaderCell: () => {
      return { style: { minWidth: '50px' } }; // Set min-width for the column
    },
    dataIndex: 'c3',
    key: 'c3',
  },
  {
    title: 'C4',
    width: '50px',
    onHeaderCell: () => {
      return { style: { minWidth: '50px' } }; // Set min-width for the column
    },
    dataIndex: 'c4',
    key: 'c4',
  },
  {
    title: 'C5',
    width: '50px',
    onHeaderCell: () => {
      return { style: { minWidth: '50px' } }; // Set min-width for the column
    },
    dataIndex: 'c5',
    key: 'c5',
  },
  {
    title: 'C10',
    width: '50px',
    onHeaderCell: () => {
      return { style: { minWidth: '50px' } }; // Set min-width for the column
    },
    dataIndex: 'c10',
    key: 'c10',
  },
  {
    title: 'Status',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Status (hex)',
    width: '80px',
    onHeaderCell: () => {
      return { style: { minWidth: '80px' } }; // Set min-width for the column
    },
    dataIndex: 'statusHex',
    key: 'statusHex',
  },
  {
    title: 'DTC (hex)',
    width: '8px',
    onHeaderCell: () => {
      return { style: { minWidth: '80px' } }; // Set min-width for the column
    },
    dataIndex: 'dtcHex',
    key: 'dtcHex',
  },
  {
    title: 'Snapshot (hex)',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'snapshotHex',
    key: 'snapshotHex',
    ellipsis: true,
  },
  {
    title: 'Total Distance Miles',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoMiles',
    key: 'odoMiles',
  },
  {
    title: 'Total Distance KM',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'odoKm',
    key: 'odoKm',
  },
  {
    title: 'Dids Snapshot',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'didsInSnapshot',
    key: 'didsInSnapshot',
  },
  {
    title: 'Snapshot Decoded',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'snapshotDecoded',
    key: 'snapshotDecoded',
  },
  {
    title: 'Snapshot Dids',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'snapshotDids',
    key: 'snapshotDids',
  },
  {
    title: 'Local Signal Publisher',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'localSignalPublisher',
    key: 'localSignalPublisher',
  },
  {
    title: 'Local Signal',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'localSignal',
    key: 'localSignal',
  },
  {
    title: 'Source File',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sourceFile',
    key: 'sourceFile',
  },
  {
    title: 'Global Time',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'globalTime',
    key: 'globalTime',
  },
  {
    title: 'Event Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'eventTimestamp',
    key: 'eventTimestamp',
  },
  {
    title: 'Session Timestamp',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sessionTimestamp',
    key: 'sessionTimestamp',
  },
  {
    title: 'Data Read Type',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dataReadType',
    key: 'dataReadType',
  },
  {
    title: 'Topix Dealer Name',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixDealerName',
    key: 'topixDealerName',
  },
  {
    title: 'Topix Dealer Code',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dealerTopixCode',
    key: 'dealerTopixCode',
  },
  {
    title: 'Topix State',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'topixState',
    key: 'topixState',
  },
  {
    title: 'Topix Dealer Country',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'dealerTopixCountry',
    key: 'dealerTopixCountry',
  },
  {
    title: 'Build Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'buildDate',
    key: 'buildDate',
  },
  {
    title: 'Warranty Date',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'warrantyDate',
    key: 'warrantyDate',
  },

  {
    title: 'Country',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'country',
    key: 'country',
  },
  {
    title: 'Session Id',
    width: '100px',
    onHeaderCell: () => {
      return { style: { minWidth: '100px' } }; // Set min-width for the column
    },
    dataIndex: 'sessionId',
    key: 'sessionId',
  },
];

const GetTableHeader = (type: string) => {
  if (type === 'concern') {
    return ConcernQueryHeader;
  } else if (type === 'application') {
    return applicationQueryHeader;
  } else if (type === 'did') {
    return didQueryHeader;
  } else if (type === 'dtc') {
    return dtcQueryHeader;
  }
  return [];
};
export default GetTableHeader;
